import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { WelcomeVideo } from '../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { createDisplayLink } from '../../../../../services/helper';
import WelcomeVideoPlayer from './WelcomeVideoPlayer';

interface VideoElementProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  welcomeVideo: WelcomeVideo;
  currentIndex?: number;
  visible: boolean;
}

const VideoElement = ({ welcomeVideo, className, currentIndex = 0, visible, ...props }: VideoElementProps) => {
  const videoRef = useRef<HTMLVideoElement>(document.createElement('video'));
  const event = useSelector((state) => state.common.event);

  const [playing, setPlaying] = useState(visible && welcomeVideo.autoplay);

  useEffect(() => {
    videoRef.current.pause();
    setPlaying(visible && welcomeVideo.autoplay);
  }, [currentIndex, welcomeVideo.autoplay, visible]);

  async function trackBoothVideoImpression(boothVideoId: string, boothid?: string) {
    try {
      axios.post('/tracking/track', { event: 'VIDEO_PLAY', eventid: event?._id, args: { boothVideoId, boothid } }).catch((err) => {
        console.error(err);
      });
    } catch (err) {
      console.error(`Err > ${err}`);
    }
  }

  function handlePlayClicked() {
    if (welcomeVideo?._id) trackBoothVideoImpression(welcomeVideo?._id, welcomeVideo?.booth);
    setPlaying(true);
  }

  const videoThumbnail = welcomeVideo.thumbnail && !welcomeVideo.autoplay ? createDisplayLink(welcomeVideo.thumbnail, false) : undefined;

  if (!welcomeVideo) return <></>;

  return (
    <>
      <div {...props} className={`justify-end content-center h-0 pt-[56.25%] relative ${className}`}>
        {welcomeVideo.type === 'recording' && (
          <WelcomeVideoPlayer
            onPlay={handlePlayClicked}
            playing={playing}
            url={createDisplayLink(welcomeVideo.video)}
            light={videoThumbnail}
            onClickPreview={handlePlayClicked}
          />
        )}
        {welcomeVideo.type === 'youtube' && (
          <WelcomeVideoPlayer onPlay={handlePlayClicked} playing={playing} url={welcomeVideo.video} light={videoThumbnail} onClickPreview={handlePlayClicked} />
        )}

        {welcomeVideo.type === 'vystemboothvideo' && welcomeVideo.videoApiId && !welcomeVideo.muxId && (
          <WelcomeVideoPlayer
            muted={false} // https://developers.google.com/web/updates/2017/09/autoplay-policy-changes
            onPlay={handlePlayClicked}
            id={welcomeVideo?._id}
            playing={playing}
            url={welcomeVideo.videoApiHls || `https://cdn.api.video/vod/${welcomeVideo.videoApiId}/hls/manifest.m3u8`}
            light={videoThumbnail}
            onClickPreview={handlePlayClicked}
          />
        )}
        {welcomeVideo.type === 'vystemboothvideo' && welcomeVideo.muxId && welcomeVideo.muxPlaybackIds?.length === 1 && (
          <WelcomeVideoPlayer
            muted={false}
            onPlay={handlePlayClicked}
            id={welcomeVideo?._id}
            playing={playing}
            url={`https://stream.mux.com/${welcomeVideo.muxPlaybackIds[0].id}.m3u8`}
            light={videoThumbnail}
            onClickPreview={handlePlayClicked}
          />
        )}
      </div>
    </>
  );
};

export default VideoElement;
